import CrudPage from "@/components/CrudPage";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const baseFields = [
  { key: "agente", label: "Login do agente", mono: true, placeholder: "1000" },
  { key: "nome", label: "Nome" },
  { key: "senha", label: "Senha", type: "password", mono: true },
  { key: "status", label: "Status", type: "select", options: [
    { value: "offline", label: "Offline" },
    { value: "available", label: "Disponivel" },
    { value: "on_break", label: "Pausa" },
    { value: "busy", label: "Ocupado" },
  ] },
  { key: "max_no_answer", label: "Max sem resposta", type: "number" },
  { key: "wrap_up_time", label: "Wrap-up", type: "number" },
  { key: "recording_enabled", label: "Gravar chamadas do agente", type: "toggle" },
  { key: "enabled", label: "Ativo", type: "toggle" },
];

export default function CallCenterAgents() {
  const { user: current } = useAuth();
  const isSuperadmin = current?.role === "superadmin";
  const [queues, setQueues] = useState([]);
  const [tenants, setTenants] = useState([]);
  useEffect(() => {
    api.get("/filas", isSuperadmin ? { skipTenantScope: true } : undefined).then(({ data }) => setQueues(data || [])).catch(() => setQueues([]));
    if (isSuperadmin) api.get("/tenants").then(({ data }) => setTenants(data || [])).catch(() => setTenants([]));
  }, [isSuperadmin]);
  const tenantOptions = (tenants || []).map((row) => ({ value: row.id, label: row.nome }));
  const tenantNameById = Object.fromEntries((tenants || []).map((row) => [String(row.id || "").trim(), String(row.nome || "").trim()]));
  const queuesByTenant = (tenantId) => {
    const normalizedTenantId = String(tenantId || "").trim();
    if (!normalizedTenantId) return [];
    const normalizedTenantName = String(tenantNameById[normalizedTenantId] || "").trim().toLowerCase();
    return queues.filter((row) => {
      const rowTenantId = String(row?.tenant_id || "").trim();
      const rowTenantName = String(
        row?.tenant_name ||
        row?.tenant_nome ||
        row?.cliente ||
        row?.client ||
        row?.company_name ||
        "",
      ).trim().toLowerCase();
      return rowTenantId === normalizedTenantId || (!!normalizedTenantName && rowTenantName === normalizedTenantName);
    });
  };
  const fields = [
    ...(isSuperadmin ? [{
      key: "tenant_id",
      label: "Cliente",
      type: "select",
      full: true,
      options: [
        { value: "", label: "-- selecione o cliente --" },
        ...tenantOptions,
      ],
      onChange: (next, tenantId) => ({
        ...next,
        tenant_id: tenantId,
        filas: [],
      }),
    }] : []),
    ...baseFields.slice(0, 2),
    {
      key: "filas",
      label: "Grupo de filas do agente",
      type: "checkbox-list",
      full: true,
      options: (form) => queuesByTenant(isSuperadmin ? form.tenant_id : current?.tenant_id).map((row) => ({
        value: String(row.numero || ""),
        label: `${row.numero} - ${row.nome}`,
        hint: row.enabled === false ? "fila inativa" : (row.estrategia || "fila"),
      })),
      hint: "Selecione as filas que este agente pode atender.",
    },
    ...baseFields.slice(2),
  ];
  return (
    <CrudPage
      title="Agentes Call Center"
      subtitle="Cadastro exclusivo do agente do call center"
      endpoint="/callcenter-agents"
      testidPrefix="callcenter-agents"
      fields={fields}
      headers={["Login", "Nome", "Filas", "Ramal ativo", "Estado", "Status"]}
      defaultValues={{ tenant_id: isSuperadmin ? "" : (current?.tenant_id || ""), agente: "", nome: "", senha: "", filas: [], status: "offline", max_no_answer: 3, wrap_up_time: 10, reject_delay_time: 10, busy_delay_time: 60, recording_enabled: false, enabled: true }}
      transformFormOpen={(f) => ({ ...f, tenant_id: f.tenant_id || (isSuperadmin ? "" : (current?.tenant_id || "")), filas: Array.isArray(f.filas) ? f.filas : [] })}
      transformSubmit={(f, editing) => ({
        ...f,
        ramal: "",
        user_id: "",
        user_email: "",
        filas: Array.isArray(f.filas) ? f.filas.filter(Boolean) : (editing?.filas || []),
      })}
      renderRow={(r) => <>
        <td className="font-mono">{r.agente}</td>
        <td>{r.nome}</td>
        <td className="font-mono text-xs">{(r.filas || []).join(", ") || "-"}</td>
        <td className="font-mono">{r.active_extension || r.ramal || "-"}</td>
        <td>{r.status || "offline"}</td>
        <td>{r.enabled ? "Ativo" : "Inativo"}</td>
      </>}
    />
  );
}
